import axios from "axios";
import UtilServices from "./UtilServices";

const ApiService = {
  //POST
  async post(url, params) {
    try {
      params.planos = UtilServices.getStorage("dadosusuario")?.planos || [];
      const paramsCrypto = UtilServices.cryptografar(params);
      const response = await axios.post(url, paramsCrypto);
      return UtilServices.decompressData(response.data);
    } catch (error) {
      UtilServices.errorApi(error);
    }
  },
  async postSemError(url, params) {
    try {
      const paramsCrypto = UtilServices.cryptografar(params);
      const response = await axios.post(url, paramsCrypto);
      return UtilServices.decompressData(response.data);
    } catch (error) {
      console.error("error", error);
    }
  },
  //GET
  async get(url, params, onError = null) {
    try {
      params.planos = UtilServices.getStorage("dadosusuario")?.planos || [];
      const paramsCrypto = UtilServices.cryptografar(params);
      const response = await axios.get(url, {
        params: paramsCrypto,
      });
      return UtilServices.decompressData(response.data);
    } catch (error) {
      UtilServices.errorApi(error, onError);
    }
  },
  //GET SESSAO
  async getSessao(url) {
    try {
      const response = await axios.get(url, {});
      return response.data;
    } catch (error) {
      UtilServices.errorApi(error);
    }
  },
  //GET SESSAO ERRO
  async getSessaoSemError(url) {
    const response = await axios.get(url, {});
    return response.data;
  },
  //PUT
  async put(url, params) {
    try {
      params.planos = UtilServices.getStorage("dadosusuario")?.planos || [];
      const paramsCrypto = UtilServices.cryptografar(params);
      const response = await axios.put(url, paramsCrypto);
      return UtilServices.decompressData(response.data);
    } catch (error) {
      UtilServices.errorApi(error);
    }
  },
  //DELETE
  async delete(url, params) {
    try {
      params.planos = UtilServices.getStorage("dadosusuario")?.planos || [];
      const paramsCrypto = UtilServices.cryptografar(params);
      const response = await axios.delete(url, {
        params: paramsCrypto,
      });
      return UtilServices.decompressData(response.data);
    } catch (error) {
      UtilServices.errorApi(error);
    }
  },
};

const EndPointServices = {
  /* --- Autenticar --- */
  Autentica_Login(params) {
    const endpoint = `/Login/Login`;
    return ApiService.post(endpoint, params);
  },
  Autentica_VerificaSessao() {
    const endpoint = `/Login/VerificaSessao`;
    return ApiService.getSessao(endpoint);
  },
  Autentica_VerificaSessaoSemError() {
    const endpoint = `/Login/VerificaSessao`;
    return ApiService.getSessaoSemError(endpoint);
  },
  Autentica_AtualizaSenha(params) {
    const endpoint = `/Login/AtualizaSenha`;
    return ApiService.post(endpoint, params);
  },
  Autentica_Menu(params) {
    const endpoint = `/Login/Menu`;
    return ApiService.get(endpoint, params);
  },
  Autentica_CadastrarUsuario(params) {
    const endpoint = `/Login/CadastrarUsuario`;
    return ApiService.post(endpoint, params);
  },
  Autentica_EnviarCodigoEmail(params) {
    const endpoint = `/Login/EnviarCodigoEmail`;
    return ApiService.post(endpoint, params);
  },
  Autentica_VerificarEmail(params) {
    const endpoint = `/Login/VerificarEmail`;
    return ApiService.get(endpoint, params);
  },

  /* --- Rpas --- */
  Rpa_ConsultaEmpresa(params) {
    const endpoint = `/RPA/ConsultaEmpresa`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaEmpresaRegraVinculada(params) {
    const endpoint = `/RPA/ConsultaEmpresaRegraVinculada`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaEmpresaArquivoEFD(params) {
    const endpoint = `/RPA/ConsultaEmpresaArquivo`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaLstCompetencia(params) {
    const endpoint = `/RPA/ConsultaLstCompetencia`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaLstEmpresa(params) {
    const endpoint = `/RPA/ConsultaLstEmpresa`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaBase64(params) {
    const endpoint = `/RPA/ConsultaBase64`;
    return ApiService.get(endpoint, params);
  },
  Rpa_AdicionarEmpresaArquivo(params) {
    const endpoint = `/RPA/AdicionarEmpresaArquivo`;
    return ApiService.post(endpoint, params);
  },
  Rpa_DeletaEmpresa(params) {
    const endpoint = `/RPA/DeletaEmpresa`;
    return ApiService.delete(endpoint, params);
  },
  Rpa_CreateEmpresaReprocessar(params) {
    const endpoint = `/RPA/CreateEmpresaReprocessar`;
    return ApiService.post(endpoint, params);
  },

  /* --- Regras --- */
  Rpa_ConsultaRegra(params) {
    const endpoint = `/RPA/ConsultaRegra`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaRegraDetalhada(params) {
    const endpoint = `/RPA/ConsultaRegraDetalhada`;
    return ApiService.get(endpoint, params);
  },
  Rpa_AdicionarNovaRegra(params) {
    const endpoint = `/RPA/AdicionarNovaRegra`;
    return ApiService.post(endpoint, params);
  },
  Rpa_AdicionarRegraVinculada(params) {
    const endpoint = `/RPA/AdicionarRegraVinculada`;
    return ApiService.post(endpoint, params);
  },
  Rpa_DeletaRegra(params) {
    const endpoint = `/RPA/DeletaRegra`;
    return ApiService.delete(endpoint, params);
  },

  /* --- SPED --- */
  Rpa_ConsultaRegistrosSPED(params) {
    const endpoint = `/RPA/ConsultaRegistrosSPED`;
    return ApiService.get(endpoint, params);
  },

  /* --- Agendadores --- */
  Rpa_AdicionarAgendador(params) {
    const endpoint = `/RPA/AdicionarAgendador`;
    return ApiService.post(endpoint, params);
  },
  Rpa_ConsultaAgendador(params) {
    const endpoint = `/RPA/ConsultaAgendador`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaAgendadorEmpresa(params) {
    const endpoint = `/RPA/ConsultaAgendadorEmpresa`;
    return ApiService.get(endpoint, params);
  },
  Rpa_ConsultaAgendadorEmpresaCadastro(params) {
    const endpoint = `/RPA/ConsultaAgendadorEmpresaCadastrado`;
    return ApiService.get(endpoint, params);
  },
  Rpa_AtualizarAgendador(params) {
    const endpoint = `/RPA/AtualizarAgendador`;
    return ApiService.post(endpoint, params);
  },

  /* --- Partilha --- */
  Partilha_ConsultaOperadores(params) {
    const endpoint = `/Partilha/ConsultaOperadores`;
    return ApiService.get(endpoint, params);
  },
  Partilha_ConsultaLog(params) {
    const endpoint = `/Partilha/ConsultaLog`;
    return ApiService.get(endpoint, params);
  },
  Partilha_TourClose(params) {
    const endpoint = `/Partilha/AtualizaTourClosed`;
    return ApiService.post(endpoint, params);
  },

  /* --- Cliente --- */
  Cliente_ConsultaCertificado(params) {
    const endpoint = `/Cliente/ConsultaCertificado`;
    return ApiService.get(endpoint, params);
  },
  Cliente_ConsultaLstDominio(params) {
    const endpoint = `/Cliente/ConsultaLstDominio`;
    return ApiService.get(endpoint, params);
  },
  Cliente_ConsultaEmpresa(params) {
    const endpoint = `/Cliente/ConsultaEmpresa`;
    return ApiService.get(endpoint, params);
  },
  Cliente_CadastrarCertificado(params) {
    const endpoint = `/Cliente/CadastrarCertificado`;
    return ApiService.post(endpoint, params);
  },
  Cliente_CadastraVinculo(params) {
    const endpoint = `/Cliente/CadastraVinculo`;
    return ApiService.post(endpoint, params);
  },
  Cliente_CadastraDominio(params) {
    const endpoint = `/Cliente/CadastraDominio`;
    return ApiService.post(endpoint, params);
  },
  Cliente_DeletaCertificado(params) {
    const endpoint = `/Cliente/DeletaCertificado`;
    return ApiService.delete(endpoint, params);
  },
  Cliente_DeletaDominio(params) {
    const endpoint = `/Cliente/DeletaDominio`;
    return ApiService.delete(endpoint, params);
  },
  Cliente_DeletaEmpresa(params) {
    const endpoint = `/Cliente/DeletaEmpresa`;
    return ApiService.delete(endpoint, params);
  },
  /* --- ReceitaBX --- */
  ReceitaBX_CadastraConsulta(params) {
    const endpoint = `/RPA/AdicionaReceitaBX`;
    return ApiService.post(endpoint, params);
  },

  /* ---IBSCBS --- */
  IBSCBS_ConsultaServico(params, onError = null) {
    const endpoint = `/IBSCBS/ConsultaServico`;
    return ApiService.get(endpoint, params, onError);
  },
  IBSCBS_ConsultaComercio(params, onError = null) {
    const endpoint = `/IBSCBS/ConsultaComercio`;
    return ApiService.get(endpoint, params, onError);
  },

  /* --- Apis Externas --- */
  async Externo_VerificaTokenCaptcha(params) {
    const endpoint = `/Login/VerificaTokenCaptcha`;
    return ApiService.postSemError(endpoint, params);
  },

  /* --- Pay --- */
  Partilha_PayMercadoPago(params) {
    const endpoint = `/Partilha/PayMercadoPago`;
    return ApiService.post(endpoint, params);
  },
  Partilha_PayStatus(params) {
    const endpoint = `/Partilha/PayConsultaStatus`;
    return ApiService.get(endpoint, params);
  },
};

export default EndPointServices;
